import { styled, ToggleButton, ToggleButtonGroup } from '@mui/material';
import moment from 'moment';

const StyledToggle = styled(ToggleButton)(({ theme }) => ({
  borderRadius: '6px!important',
  margin: '8px',
  minWidth: 32,
  height: 32,
  marginInlineStart: '8px!important',
  marginInlineEnd: '0!important',
  fontSize: '1rem',
  background: theme.palette.background.paper,
  border: `1px solid ${theme.palette.mb.control}!important`,
  color: theme.palette.text.primary,
  '&.Mui-selected, &.Mui-selected:hover': {
    color: `${theme.palette.primary.contrastText}!important`,
    background: theme.palette.primary.main,
  },
  '&:hover': {
    borderColor: theme.palette.primary.main,
  },
  '&:hover:selected': {
    color: `${theme.palette.primary.contrastText}!important`,
    background: theme.palette.primary.light,
  },
  '&.unselected-dimmed:not(.Mui-selected)': {
    background: theme.palette.mb.ground,
    color: theme.palette.text.disabled,
    border: `1px solid ${theme.palette.divider}!important`,
  },
}));

const ToggleDays = (props) => {
  const { days, setDays, dimUnselected } = props;

  return (
    <ToggleButtonGroup
      size="small"
      arial-label="Days of the week"
      value={days}
      onChange={(event, value) => setDays(value)}>
      {moment.weekdaysMin().map((label, index) => (
        <StyledToggle
          key={index}
          value={index}
          aria-label={moment.weekdays(index)}
          className={dimUnselected ? 'unselected-dimmed' : ''}>
          {label.charAt(0)}
        </StyledToggle>
      ))}
    </ToggleButtonGroup>
  );
};

export default ToggleDays;
